import React from "react";

const BounchLoading = () => {
  return (
    <div className="bouncing-loader">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default BounchLoading;
